import { useMemo, useState, useCallback } from "react";
import { Route, Routes } from "react-router-dom";
import { Layout, FloatButton, ConfigProvider, App as AntApp } from "antd";
import { createIntl, createIntlCache, RawIntlProvider } from "react-intl";

import csCZ from "../../messages/csCZ";
import enGB from "../../messages/enGB";

import antCSCZ from "antd/locale/cs_CZ";

import Home from "../home";
import SignIn from "../signIn";
import NoRoles from "../noRoles";
import colors from "../../colors";
import Registration from "../registration";
import OldRegistration from "../oldRegistration";
import NavBar from "../../components/app/navBar";
import Footer from "../../components/app/footer";
import Func from "../../components/app/globalApp";
import SideBar from "../../components/app/sideBar";
//import PrivateRoute from "../../components/app/privateRoute";
import FingerprintProvider from "../../components/fingerprintProvider";
import EnvironmentBackground from "../../components/app/environmentBackground";

import "./index.css";

const { Content } = Layout;

const initialLocale = "cs-CZ";
const defaultLanguageSetting = { locale: initialLocale, antLocale: antCSCZ };

const cache = createIntlCache();
export let intl = createIntl({ locale: initialLocale, messages: csCZ }, cache);

const getLocale = (locale) => (locale === "en-GB" ? enGB : csCZ);

function App() {
  const nonce = useMemo(() => {
    const node = document.getElementById("nonce-value");
    return node ? node.getAttribute("value") : "";
  }, []);

  const [languageSetting, setLanguageSetting] = useState(
    defaultLanguageSetting
  );

  const handleLanguageSet = useCallback((newSetting) => {
    setLanguageSetting(newSetting);
    intl = createIntl(
      {
        locale: newSetting.locale,
        messages: getLocale(newSetting.locale),
      },
      cache
    );
    document.documentElement.lang = newSetting.locale;
  }, []);

  return (
    <RawIntlProvider value={intl}>
      <ConfigProvider
        csp={{ nonce }}
        locale={languageSetting.antLocale}
        theme={{
          token: {
            colorPrimary: colors.YELLOW,
          },
        }}
      >
        <AntApp>
          <Func />
          <FingerprintProvider>
            <Layout className="app">
              <NavBar onLanguageSetting={handleLanguageSet} />
              <Layout>
                <SideBar />
                <Content className="app-content">
                  <Routes>
                    <Route path="/empty" element={null} />
                    <Route path="/sign-in" element={<SignIn />} />
                    <Route path="/no-roles" element={<NoRoles />} />
                    <Route path="/form" element={<Registration />} />
                    <Route
                      exact
                      path="/form/:id"
                      element={<OldRegistration />}
                    />
                    {/* Routes without a path always match. */}
                    <Route path="/" element={<Home />} />
                  </Routes>
                </Content>
              </Layout>
              <Footer />
              <FloatButton.BackTop />
              <EnvironmentBackground />
            </Layout>
          </FingerprintProvider>
        </AntApp>
      </ConfigProvider>
    </RawIntlProvider>
  );
}

export default App;
